import * as Yup from 'yup';

export const feedbackFormSchema = Yup.object({
  text: Yup.string().required('Feedback text is required')
});
